import { createRoot } from 'react-dom/client';
import './index.css';

import App from './App';
import { createTheme } from '@hiiretail/synergy-ui';
import { ThemeProvider } from 'styled-components';
import { QueryClient } from 'react-query';
import { CommonProviders } from '@hiiretail/core';
import { AppContent } from './common/components/AppContent/AppContent';
import { DEFAULT_QUERY_SETTINGS } from './common';
import { Language } from '@hiiretail/core/dist/types/common-providers/CommonProviders.types';
import messages from './i18n';
import axios from 'axios';
import { addCorrelationIdInterceptor } from '@hiiretail/core';
import { FoundationProvider } from '@hiiretail/react-foundation-ui';

const theme = createTheme();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...DEFAULT_QUERY_SETTINGS,
    },
  },
});

axios.interceptors.request.use(addCorrelationIdInterceptor);

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root container '#root' not found in document. Check your index.html.");
}
const root = createRoot(container);

root.render(
  <CommonProviders
    serviceName="iam-ui-new"
    queryClient={queryClient}
    strict={false}
    locale="en"
    intlMessages={messages as unknown as Record<Language, Record<string, string>>}
  >
    <FoundationProvider>
      <ThemeProvider theme={theme}>
        <AppContent>
          <App />
        </AppContent>
      </ThemeProvider>
    </FoundationProvider>
  </CommonProviders>,
);
